// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F5AW","question":"styles_question__XxK4j","inputVisibleButton":"styles_inputVisibleButton__17Nk1","note":"styles_note__3hngS"};